// extracted by mini-css-extract-plugin
export default {"form":"checkout_form__tCF0Y","control":"checkout_control__uypBz","actions":"checkout_actions__k-VEU","submit":"checkout_submit__ru8zq","invalid":"checkout_invalid__nyC0m"};